import { v4 as uuid } from "uuid";

import { createSlice, current, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import {TIMER} from "@/actions/globalConst";

import moment from 'moment';

import DB from "@/models/DB";
import {TimerModel, TimerTimeModel} from '@/models/TimerModel';

import TimeRegistrationAPI from "@/api/TimeRegistrationAPI";



export const initialState = {
    initItems: [],
    timers: [],
    activeTimer: {},
    apiState: TIMER.API_INIT,
    key: "",
    error: null
};

const rejectEventHandlerSchedule=((state, action) => {
    state.error = action.payload;
    state.key = uuid().slice(0, 8);

});
const pendingEventHandlerSchedule=((state, action) => {
    state.key = uuid().slice(0, 8);
    
})
let fullFilledEventHandlerSchedule= ( (state, action) => {
    if(action.payload.timerModel) {
        if(state.activeTimer) {
            state.activeTimer.state = 0;
        }
        state.activeTimer = action.payload.timerModel;   
        state.timers.push(state.activeTimer);
        
    }
        
    if(action.type == 'timer_api_start/fulfilled') {
        if(action.payload.data.test.key) {
            state.activeTimer.key = action.payload.data.test.key;
        }
    }
        
    if(action.type == 'stopTimer/fulfilled') {
        if(state.activeTimer) {
            state.activeTimer.stopTimer();
            state.activeTimer = null;
        }
    }
    
    
    
    return state;
})  


let task = null;
const TimerReducer = createSlice({
  name: 'Timer',
  initialState,
  reducers: {
      startTimer:  ((state = null, action = null) => {
            //state.key = uuid().slice(0, 8);
            if(state.activeTimer) {
                state.activeTimer.state = 0;
            }
            
            let timerModel = new TimerModel();
            timerModel.createNewTimer();

            
            state.activeTimer = timerModel;
            state.timers.push(state.active);

            return (state);
//            localStorage.setItem("schedule", JSON.stringify(state.dossierScheduleItems));
            //StorageHelperClass.set(STORAGE.SCHEDULE, (state.dossierScheduleItems));   
          })
  },
  extraReducers(builder) {
    task = startTimer2;
//    console.debug("extra", task)
   builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandlerSchedule(state, action)).addCase(task.rejected, (state, action) => rejectEventHandlerSchedule(state, action)).addCase(task.pending, (state, action) => pendingEventHandlerSchedule(state, action));

       task = startTimer;
   //    console.debug("extra", task)
      builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandlerSchedule(state, action)).addCase(task.rejected, (state, action) => rejectEventHandlerSchedule(state, action)).addCase(task.pending, (state, action) => pendingEventHandlerSchedule(state, action));

       task = stopTimer;
   //    console.debug("extra", task)
      builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandlerSchedule(state, action)).addCase(task.rejected, (state, action) => rejectEventHandlerSchedule(state, action)).addCase(task.pending, (state, action) => pendingEventHandlerSchedule(state, action));
   
      builder.addMatcher(
        (action) => action.type == "switchtenant/pending",
        (state, action) => {
          state.settings = {...initialState.settings};
          if(state.activeTimer instanceof TimerModel) {
            state.activeTimer.stopTimer();
          state.activeTimer = initialState.activeTimer;
          }
          state.timers = initialState.timers;
         })
      
      builder.addMatcher(
        (action) => action.type == "switchtenant/fulfilled" || action.type == 'USER_CHECKAUTH/fulfilled' || action.type == 'USER_LOGIN/fulfilled',
        (state, action) => {
            let timers = action.payload.data.data?.timers;
            if(!timers) {
                timers = action.payload.data?.timers;
            }
            
            if(timers) {
                if(timers?.open) {
                    let openTimers = timers?.open;
                    for(let i in openTimers) {
                        let timerData = openTimers[i].data;
                        timerData = {...timerData, key: openTimers[i].key}
                        if(timerData) {
                            let timerModel = new TimerModel(timerData);
                            state.timers.push(timerModel);
                            state.activeTimer = timerModel;
                            
                            const event = new CustomEvent('timer.start', {detail: {timerModel:timerModel} });
                            event["data"] = "testje";
                            
                            window.dispatchEvent(event);
                            
                        }
                    }
                }
            }
         console.debug( "switch tenant", (state.activeTimer) );
          //setState(action?.payload?.data, state);
            
         })

         builder.addMatcher(
           (action) => action.type == "chat/receiveMessage" && action.event ,
           (state, action) => {
                let data = null;
                if(action.event && action.event.type == "timer") {
                    if(action.event.action == "start" && (!state.activeTimer || state.activeTimer && action.event.dataObj.data.key !== state.activeTimer.key)  ) {
let data = null;
if(action.event.dataObj.data.data) {
    data = action.event.dataObj.data.data;
}    
                            let timerModel = new TimerModel(data);
                            if(data === null) {
                                timerModel.createNewTimer();
                                } else {
                                    timerModel.key = action.event.dataObj.data.key;
                            }

                            state.activeTimer = timerModel;   
                            state.timers.push(state.activeTimer);

                            const event = new CustomEvent(action.event.type+"."+action.event.action, {detail: {timerModel:timerModel} });
                            event["data"] = "testje";
                            
                            window.dispatchEvent(event);
                            
                        
                    }

                    if(action.event.action == "stop" &&  state.activeTimer) {
                        state.activeTimer.stopTimer();
                        state.activeTimer = null;
                        
                        const event = new CustomEvent(action.event.type+"."+action.event.action, {detail: action.event});
                        event["data"] = "testje";
                        window.dispatchEvent(event);
                        
                    }
                    
                }
            
            })
         
  }
  });
  

  export const startTimer2 = createAsyncThunk("startTimer2", async (data:any, event) => {
    console.debug(event.getState().TimerReducer);
    let timerModel = new TimerModel();
    timerModel.createNewTimer();
    return new Promise((resolve) => {
        resolve({timerModel: timerModel, timers:event.getState().TimerReducer.timers });
      });
  });

  export const stopTimer = createAsyncThunk("stopTimer", async (data:any, event) => {
    return new Promise((resolve) => {
        resolve({});
      });
  });


export const startTimer = createAsyncThunk(TIMER.API_START_TIMER, async (data:any, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          console.log("???",data)
          response = await TimeRegistrationAPI.startTimer(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const endTimer = createAsyncThunk(TIMER.API_STOP_TIMER, async (data:any, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          console.log("???",data)
          response = await TimeRegistrationAPI.stopTimer(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const {} = TimerReducer.actions;
export default TimerReducer.reducer